import { Type } from 'class-transformer';

export class BoardApprovalActionParameterDto {
    responseToOwner: string;
    notes: string;
    actionOnBehalfOf: string;
    isClosed: boolean;
    communityId: number;
    processId: string;
    boardMemberUserId: string;
    clearCache = false;

    @Type(() => Date)
    addedOn: Date;
}
